import React from "react";
import { search } from "../asset";

interface CustomInputProps {
  name: string;
  value: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  type?:
    | "email"
    | "text"
    | "password"
    | "number"
    | "date"
    | "tel"
    | "search"
    | "radio"
    | "time"
    | "checkbox";
  placeholder?: string;
  required?: boolean;
  label?: string;
  id?: string;
  className?: string;
  inputClassName?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
  handleSearch?: () => void;
  isSearchButton?: boolean;
  min?: string;
  max?: string;
  autoFocus?: boolean;
  isTextarea?: boolean;
  rows?: number;
  checked?: boolean;
  maxLength?: number;
  showCounter?: boolean;
}

export default function CustomInput({
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  required = false,
  label,
  id,
  inputClassName = "",
  className = "",
  readOnly,
  disabled,
  onBlur,
  handleSearch,
  isSearchButton = false,
  min,
  max,
  autoFocus = false,
  isTextarea,
  rows,
  checked,
  maxLength,
  showCounter,
}: CustomInputProps) {
  return (
    <div
      className={`flex flex-col gap-2 w-full relative ${className} ${
        disabled ? "opacity-50" : ""
      }`}>
      {label && (
        <label
          htmlFor={id || name}
          className="text-[13px] font-semibold text-neutral-400 flex items-center">
          {label}
          {required && <span className="text-error-500">*</span>}
        </label>
      )}

      {isTextarea ? (
        <div className="relative w-full">
          <textarea
            id={id || name}
            name={name}
            value={value}
            onChange={(e) => onChange(e)}
            placeholder={placeholder}
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            rows={rows || 4}
            maxLength={maxLength}
            className={`px-4 py-[10px] border border-neutral-100 placeholder:text-neutral-200 font-normal rounded outline-none text-[13px] text-gray-800 transition w-full pr-12 ${inputClassName} ${
              readOnly ? "bg-background-400" : ""
            }`}
          />

          {showCounter && maxLength && (
            <span className="absolute bottom-3 right-3 text-[11px] text-neutral-400 pointer-events-none">
              {value.length}/{maxLength}
            </span>
          )}
        </div>
      ) : (
        <input
          id={id || name}
          name={name}
          type={type}
          value={value}
          checked={checked}
          onBlur={onBlur}
          onChange={(e) => onChange(e)}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          disabled={disabled}
          min={min}
          max={max}
          autoFocus={autoFocus}
          className={`px-4 py-[10px] border border-neutral-100 placeholder:text-neutral-200 font-normal rounded outline-none text-[13px] text-gray-800 placeholder-gray-400 transition ${inputClassName} ${
            readOnly ? "bg-background-200" : ""
          }`}
        />
      )}
      {isSearchButton && (
        <img
          src={search}
          alt="search"
          onClick={handleSearch}
          className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 cursor-pointer hover:opacity-70 transition"
        />
      )}
    </div>
  );
}
